// MARK://dhk8/storefront/components/BusinessIdentity
// Identidad del NEGOCIO dentro del contenido (no en el header). El header de las
// páginas públicas de plataforma (fila/reservas/consulta) es NintaiGO; el negocio
// (logo + nombre) se muestra aquí, arriba de la tarjeta.

import type { TenantBranding } from '../lib/branding.js'

export default function BusinessIdentity({ branding }: { branding: TenantBranding }) {
  const name =
    branding.displayName && branding.displayName.trim().toLowerCase() !== 'nintaigo'
      ? branding.displayName
      : null
  if (!name && !branding.logoUrl) return null
  return (
    <div className="sf-biz">
      {branding.logoUrl ? (
        <img className="sf-biz__logo" src={branding.logoUrl} alt={name ?? 'Negocio'} loading="eager" decoding="async" />
      ) : (
        <div className="sf-biz__logo sf-biz__logo--placeholder" aria-hidden="true">
          {(name ?? '?').charAt(0)}
        </div>
      )}
      {name && <span className="sf-biz__name">{name}</span>}
    </div>
  )
}
